import apiFetch from '../apiFetch'

export default function (conditionDocumentalId, token, conditionDocumental) {
  return apiFetch({ endPoint: `conditionDocumental/${conditionDocumentalId}`, method: 'PUT', body: conditionDocumental, token: token })
}
